import styles from './Card.module.scss';

import classnames from 'classnames';
import { FaChevronDown } from 'react-icons/fa';
import { AiFillCreditCard } from 'react-icons/ai';

interface CardProps {
  last4?: string;
  title?: string;
  disabled?: boolean;
  onClick: () => void;
}

const Card: React.FC<CardProps> = ({ last4, title, disabled, onClick }) => (
  <div
    data-testid="payment-method"
    className={classnames(styles.card, {
      [styles.disabled]: disabled
    })}
    onClick={onClick}
  >
    <div className={styles.cardNumberWrapper}>
      <AiFillCreditCard size="20px" />
      <span className={styles.cardNumber}>
        {title || `**** **** **** ${last4 || ''}`}
      </span>
    </div>
    <FaChevronDown size="14px" />
  </div>
);

export default Card;
